// extracted by mini-css-extract-plugin
export default {"detallesBtn":"Detalles_detallesBtn__-aTeU"};